module.exports = __webpack_public_path__ + "f8f7339c3d7f829d4745074d2f1e7a1e.png";